import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  setLogLevel,
  getDoc,
  getDocs,
  DocumentReference,
  Query,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// During unit tests we don't want to initialize a real Firebase app. The SDK
// would attempt to validate API keys and connect to the network which isn't
// available in the test environment. Vitest exposes `import.meta.vitest` which
// we can use to detect that scenario and provide harmless stubs instead.
let app: any = {};
let auth: any = {};
let db: any = {};
let functions: any = {};

// Vitest sets process.env.VITEST. Use this to skip real Firebase init during tests.
const isTest = typeof process !== 'undefined' && process.env.VITEST;

// Expose the Firebase configuration so other modules (e.g. AdminPanel) can
// forward it to backend helpers. Keeping this outside the initialization block
// ensures it is available even in test environments where we skip app init.
const isPreview = import.meta.env.VITE_IS_PREVIEW === 'true';
export const firebaseConfig = {
  apiKey: isPreview
    ? import.meta.env.VITE_FIREBASE_API_KEY_DEV
    : import.meta.env.VITE_FIREBASE_API_KEY_PROD,
  authDomain: isPreview
    ? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN_DEV
    : import.meta.env.VITE_FIREBASE_AUTH_DOMAIN_PROD,
  projectId: isPreview
    ? import.meta.env.VITE_FIREBASE_PROJECT_ID_DEV
    : import.meta.env.VITE_FIREBASE_PROJECT_ID_PROD,
  storageBucket: isPreview
    ? import.meta.env.VITE_FIREBASE_STORAGE_BUCKET_DEV
    : import.meta.env.VITE_FIREBASE_STORAGE_BUCKET_PROD,
  messagingSenderId: isPreview
    ? import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID_DEV
    : import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID_PROD,
  appId: isPreview
    ? import.meta.env.VITE_FIREBASE_APP_ID_DEV
    : import.meta.env.VITE_FIREBASE_APP_ID_PROD,
};

if (!isTest) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  functions = getFunctions(app);


  if (import.meta.env.DEV) {
    setLogLevel('debug');
    (window as any).auth = auth;
    (window as any).db = db;
    import('firebase/firestore').then((firestore) => {
      (window as any).firestore = firestore;
    });
  }
}

async function loggedGetDoc<T = any>(ref: DocumentReference<T>) {
  return getDoc(ref);
}

async function loggedGetDocs<T = any>(q: Query<T>) {
  return getDocs(q);
}

export { auth, db, functions, loggedGetDoc, loggedGetDocs };
